var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 6.99967C0.333984 3.33301 3.33398 0.333008 7.00065 0.333008C10.6673 0.333008 13.6673 3.33301 13.6673 6.99967C13.6673 10.6663 10.6673 13.6663 7.00065 13.6663C3.33398 13.6663 0.333984 10.6663 0.333984 6.99967ZM6.64747 7.85967L9.36747 9.53301C9.60747 9.67968 9.92081 9.60634 10.0675 9.37301C10.2141 9.13301 10.1341 8.81968 9.89414 8.67301L7.33414 7.13301V4.16634C7.33414 3.89301 7.10747 3.66634 6.83414 3.66634C6.56081 3.66634 6.33414 3.89301 6.32747 4.16634V7.29301C6.32747 7.52634 6.44747 7.73967 6.64747 7.85967Z",
    fill: "#001B53",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendIcon);
export default __webpack_public_path__ + "static/media/extendIcon.24e8838f72c5739279ebf2b36a06f26e.svg";
export { ForwardRef as ReactComponent };